import { chunk } from 'es-toolkit';

import { loadProductionGroupData } from './loadProductionGroupData';
import { AsyncThunkActionVoid } from './thunkActions';

export function loadProductionGroupsData(productionGroupGuids: readonly string[]): AsyncThunkActionVoid {
  return async function loadProductionGroupsThunkAction(dispatch) {
    // Loading in chunks helps avoid randomly dropping requests we were seeing when refreshing the Schedule tab with
    // production data (though not on other tabs). The cause remains ambiguous.
    for (const productionGroupGuidsChunk of chunk(productionGroupGuids, 10)) {
      const productionGroupDataPromises: Promise<void>[] = [];
      for (const productionGroupGuid of productionGroupGuidsChunk) {
        const loadProductionGroupDataPromise = dispatch(loadProductionGroupData(productionGroupGuid, false));
        productionGroupDataPromises.push(loadProductionGroupDataPromise);
      }
      await Promise.all(productionGroupDataPromises);
    }
  };
}
